import { BCExtremeGridEntities } from '@bimser/components';

export const calculateDBType = (dbType: string) => {
	switch (dbType) {
		case 'boolean':
			return BCExtremeGridEntities.ItemType.Boolean;
		case 'date':
			return BCExtremeGridEntities.ItemType.DateTime;
		case 'dateTime':
			return BCExtremeGridEntities.ItemType.DateTimeOffset;
		case 'decimal':
		case 'int':
			return BCExtremeGridEntities.ItemType.Decimal;
		default:
			return BCExtremeGridEntities.ItemType.String;
	}
};
